document.addEventListener('DOMContentLoaded', () => {
  const log = () => {}; // no-op; flip to console.log for debug
  const warn = () => {};

  const sel = {
    calc: '.product-details--simple-barricade-calculator',
    form: 'form[action*="/cart/add"]',
    variantId: 'input[name="id"]',
    optionPickers: '.single-option-selector, select[name^="options["], [data-product-variant-select]'
  };

  const getEl = (s) => document.querySelector(s);

  const getProductJSON = () => {
    const el =
      document.querySelector('[id^="ProductJson-"]') ||
      document.querySelector('script[type="application/json"][data-product]') ||
      document.querySelector('script.product-json-fallback, script[type="application/json"].product-json-fallback');
    if (!el) return null;
    try { const d = JSON.parse(el.textContent || '{}'); return Array.isArray(d.variants) ? d : null; } catch { return null; }
  };

  const getCurrentVariantId = () => {
    const idInput = getEl(sel.form)?.querySelector(sel.variantId) || getEl(sel.variantId);
    const val = idInput ? (idInput.value || '').trim() : '';
    return val ? Number(val) : null;
  };

  const getCurrentVariant = () => {
    const data = getProductJSON();
    const id = getCurrentVariantId();
    if (!data || !id) return null;
    return data.variants.find(v => Number(v.id) === id) || null;
  };

  function applyMetafieldsFor(variant) {
    const calc = getEl(sel.calc);
    if (!calc || !variant) return;

    const tag = document.querySelector(`.variant-metafields[data-variant-id="${variant.id}"]`);
    let show = false;
    if (tag) {
      try {
        const mf = JSON.parse(tag.textContent || '{}');
        show = mf.show_barricade_calculator === true || mf.show_barricade_calculator === 'true';
        const inner = mf.inner_units;
        calc.setAttribute('data-inner-units', inner ? String(inner) : '1');
      } catch {}
    }
    calc.classList.toggle('show-calculator', !!show);
  }

  // Re-evaluate on common variant/section changes
  const reevaluate = () => {
    const v = getCurrentVariant();
    applyMetafieldsFor(v);
  };

  document.addEventListener('change', (e) => {
    if (e.target.matches(sel.optionPickers) || e.target.matches(sel.variantId)) {
      setTimeout(reevaluate, 0);
    }
  });
  document.addEventListener('variant:change', () => setTimeout(reevaluate, 0));
  document.addEventListener('shopify:section:load', () => setTimeout(reevaluate, 0));

  // Mutation Observer to catch hard re-renders (some themes replace the whole form)
  const formContainer = getEl(sel.form)?.parentElement || document.body;
  const mo = new MutationObserver(() => setTimeout(reevaluate, 0));
  mo.observe(formContainer, { childList: true, subtree: true });

  // Initial pass
  setTimeout(reevaluate, 0);

  // Button handler (unchanged core)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.simple-barricade-calculator-button');
    if (!btn) return;
    e.preventDefault();

    const calc = getEl(sel.calc);
    const innerUnits = Number.parseFloat(calc?.getAttribute('data-inner-units') || '1') || 1;

    const variant = getCurrentVariant();
    let sku = variant?.sku || '';
    if (!sku) {
      const skuEl = document.querySelector('.variant-sku, .product__sku, [data-sku], meta[itemprop="sku"]');
      sku = (skuEl?.getAttribute?.('content') || skuEl?.getAttribute?.('data-sku') || skuEl?.textContent || '').trim();
    }

    let width = 0;
    if (sku.includes('HDX85') || sku.includes('LDX85') || sku.includes('BARR-')) width = 8.5;
    if (!width && /\b8\.?5\b/.test(variant?.title || '')) width = 8.5;
    if (!width) return;

    const perimeter = Number.parseFloat(document.querySelector('.simple-barricade-calculator-input')?.value || '0') || 0;
    if (perimeter <= 0) return;

    const qty = Math.ceil(perimeter / (width * innerUnits));
    const qtyInput =
      getEl(sel.form)?.querySelector('input[name="quantity"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="quantity"]') ||
      document.querySelector('input[id^="Quantity"]') ||
      document.querySelector('#quantity') ||
      document.querySelector('.quantity__input') ||
      document.querySelector('input[type="number"][name="quantity"]');
    if (!qtyInput) return;

    qtyInput.value = String(qty);
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  });
});
